// Debtor-facing facts for the payment screen.
//
// เงินต้นคงเหลือ matches the remaining-balance report column of that name
// (finance.api DashboardController / ReportController): monthly and OD Fix
// use Principal on the current scheduled statement; other open types use the
// latest paid statement Balance, and add AdditionLoan when a paid row exists.
// A zero balance falls through to that statement's Principal, same as the report.
//
// The current schedule is the earliest status Scheduled (1) by balanceOnDate.
// CheckPaymentDelay copies that principal onto a new Scheduled row and marks
// the overdue row ScheduledLate (3), so a late-only contract (the job has not
// opened the next row yet) uses the ScheduledLate row.
//
// ชำระครั้งถัดไป is that same row's balanceOnDate (the due date).
// Lawsuit contracts (type 99) do not show a principal on debtor screens.

const SCHEDULED = 1;
const SCHEDULED_LATE = 3;
const PAID = 0;
const PAID_ADVANCE = 9;
const OD_FIX = 2;
const MONTHLY = 3;
const SUE = 99;

function statementList(contract) {
  return Array.isArray(contract?.statements) ? contract.statements : [];
}

function byBalanceOnDate(a, b) {
  return new Date(a.balanceOnDate) - new Date(b.balanceOnDate);
}

export function currentSchedule(contract) {
  const open = statementList(contract).filter(
    (s) =>
      s &&
      (s.status === SCHEDULED || s.status === SCHEDULED_LATE) &&
      s.balanceOnDate
  );
  const scheduled = open
    .filter((s) => s.status === SCHEDULED)
    .sort(byBalanceOnDate);
  if (scheduled.length > 0) return scheduled[0];
  const late = open
    .filter((s) => s.status === SCHEDULED_LATE)
    .sort(byBalanceOnDate);
  return late[0] ?? null;
}

export function paymentFacts(contract) {
  const schedule = currentSchedule(contract);
  return {
    nextPaymentDate: schedule ? schedule.balanceOnDate : null,
    remainingPrincipal: remainingPrincipal(contract, schedule),
    hidePrincipal: contract?.type === SUE,
  };
}

function remainingPrincipal(contract, schedule) {
  if (!contract || contract.type === SUE || !schedule) return null;

  if (contract.type === MONTHLY || contract.type === OD_FIX) {
    return schedule.principal;
  }

  const latestPaid = statementList(contract)
    .filter(
      (s) =>
        s && (s.status === PAID || s.status === PAID_ADVANCE) && s.paymentDate
    )
    .sort((a, b) => new Date(b.paymentDate) - new Date(a.paymentDate))[0];

  let balance = latestPaid ? latestPaid.balance : schedule.balance;
  if (balance == null || balance === 0) {
    balance = schedule.principal;
  }
  if (latestPaid) {
    balance += latestPaid.additionLoan || 0;
  }
  return balance;
}
